// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1034":"bdf729ec","5975":"5bbd9d1b"}[chunkId] + ".chunk.css";
};